export default __webpack_public_path__ + "2823fbe6c0ced2062d2b18e39f009a4a.svg";